import { TmrBaseResource } from 'stylewhere/api'

export class WorkOrders extends TmrBaseResource {
  static endpoint = 'api/v1/workOrders' //tracking
}
